import { useStoreActions, useStoreState } from "store/store";

/**
 * Renders the most recent cartError set by any cart/payment thunk. Lives in
 * the app shell so every step inherits surfacing — without this, errors set
 * by updateCartThunk / submitPaymentMethodThunk would just sit in store
 * state and the user would see "click Next, nothing happens" (the original
 * bug). Step 6 also reads cartError directly for the inline coupon path; the
 * banner gives every other step a default surface without page-by-page wiring.
 */
export const CartErrorBanner = () => {
  const cartError = useStoreState((s) => s.cartError);
  const clearCartError = useStoreActions((a) => a.clearCartError);

  if (!cartError) return null;

  const isRetryable = cartError.retryable;

  return (
    <div
      role="alert"
      style={{
        margin: "12px 16px",
        padding: "10px 14px",
        borderRadius: 6,
        border: `1px solid ${isRetryable ? "#dba617" : "#d63638"}`,
        background: isRetryable ? "#fff8e1" : "#fdecea",
        color: isRetryable ? "#7c5c00" : "#a61b1b",
        fontFamily: "sans-serif",
        fontSize: 14,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12,
      }}
    >
      <div>
        <strong>{isRetryable ? "Try again — " : "Action needed — "}</strong>
        {cartError.message}
      </div>
      <button
        type="button"
        onClick={() => clearCartError()}
        aria-label="Dismiss"
        style={{
          background: "transparent",
          border: "none",
          fontSize: 18,
          lineHeight: 1,
          cursor: "pointer",
          color: "inherit",
        }}
      >
        ×
      </button>
    </div>
  );
};

export default CartErrorBanner;
